/* Product availability and selling plans are read from current Shopify product JSON. */
(() => {
  'use strict';
  const config = window.BasicShopify || {};
  const cart = window.BasicCart;
  if (!cart) return;
  const lang = document.documentElement.lang.slice(0, 2);
  const dictionaries = {
    fr:{checking:'Vérification de la disponibilité…', unavailable:'Cette sélection est indisponible pour le moment.', failed:'La disponibilité n’a pas pu être vérifiée. Recharge la page pour réessayer.', note:'', shipping:'Au paiement', freeShipping:'Offerte', totalSuffix:' + livraison', checkout:'Passer au paiement', paymentNote:'Livraison au paiement.', giftAdded:'Cadeau ajouté.', giftUnavailable:'Cadeau indisponible pour le moment.', rewards:'Livraison et avantages confirmés au paiement.', updated:'Panier mis à jour.', busy:'Mise à jour du panier…', planLegend:'Comment recevoir ton déodorant ?', once:'Achat ponctuel', subscribe:'Je m’abonne', frequency:'Fréquence de livraison', planUnavailable:'Cet abonnement n’est pas disponible pour la variante choisie.'},
    de:{checking:'Verfügbarkeit wird geprüft…', unavailable:'Diese Auswahl ist derzeit nicht verfügbar.', failed:'Die Verfügbarkeit konnte nicht geprüft werden. Laden Sie die Seite erneut.', note:'', shipping:'An der Kasse', freeShipping:'Kostenlos', totalSuffix:' + Versand', checkout:'Zur Kasse', paymentNote:'Versand an der Kasse.', giftAdded:'Geschenk hinzugefügt.', giftUnavailable:'Geschenk derzeit nicht verfügbar.', rewards:'Versand und Vorteile werden an der Kasse bestätigt.', updated:'Warenkorb aktualisiert.', busy:'Warenkorb wird aktualisiert…', planLegend:'Wie möchten Sie Ihr Deo erhalten?', once:'Einmalkauf', subscribe:'Abonnieren', frequency:'Lieferhäufigkeit', planUnavailable:'Dieses Abonnement ist für die ausgewählte Variante nicht verfügbar.'},
    en:{checking:'Checking availability…', unavailable:'This selection is currently unavailable.', failed:'Availability could not be checked. Reload the page to try again.', note:'', shipping:'At checkout', freeShipping:'Free', totalSuffix:' + shipping', checkout:'Proceed to checkout', paymentNote:'Shipping at checkout.', giftAdded:'Gift added.', giftUnavailable:'Gift currently unavailable.', rewards:'Shipping and benefits are confirmed at checkout.', updated:'Cart updated.', busy:'Updating your cart…', planLegend:'How would you like to receive your deodorant?', once:'One-time purchase', subscribe:'Subscribe', frequency:'Delivery frequency', planUnavailable:'This subscription is not available for the selected variant.'}
  };
  const strings = dictionaries[lang] || dictionaries.fr;
  const savedWord = {fr:'économisés',de:'gespart',en:'saved'}[lang] || 'économisés';
  const savingsLabel = {fr:'Économie',de:'Ersparnis',en:'Savings'}[lang] || 'Économie';
  const cartDiscountLabels = ({
    fr:{before:'Articles avant remise panier',discount:'Remise panier',after:'Sous-total après remise'},
    de:{before:'Artikel vor Warenkorbrabatt',discount:'Warenkorbrabatt',after:'Zwischensumme nach Rabatt'},
    en:{before:'Items before cart discount',discount:'Cart discount',after:'Subtotal after discount'}
  })[lang] || {before:'Articles avant remise panier',discount:'Remise panier',after:'Sous-total après remise'};
  const cartLabels = ({
    fr:{remove:'Retirer',empty:'0 produit',selection:'sélection',selections:'sélections',removeAria:title=>`Retirer ${title} du panier`,quantityAria:title=>`Nombre de sélections de ${title}`,minusAria:title=>`Retirer une sélection de ${title}`,plusAria:title=>`Ajouter une sélection de ${title}`},
    de:{remove:'Entfernen',empty:'0 Produkte',selection:'Auswahl',selections:'Auswahlen',removeAria:title=>`${title} aus dem Warenkorb entfernen`,quantityAria:title=>`Anzahl der Auswahlen für ${title}`,minusAria:title=>`Eine Auswahl von ${title} entfernen`,plusAria:title=>`Eine Auswahl von ${title} hinzufügen`},
    en:{remove:'Remove',empty:'0 products',selection:'selection',selections:'selections',removeAria:title=>`Remove ${title} from your cart`,quantityAria:title=>`Number of selections of ${title}`,minusAria:title=>`Remove one selection of ${title}`,plusAria:title=>`Add one selection of ${title}`}
  })[lang] || {remove:'Retirer',empty:'0 produit',selection:'sélection',selections:'sélections',removeAria:title=>`Retirer ${title} du panier`,quantityAria:title=>`Nombre de sélections de ${title}`,minusAria:title=>`Retirer une sélection de ${title}`,plusAria:title=>`Ajouter une sélection de ${title}`};
  const drawerLabels = ({
    fr:{eyebrow:'TES ESSENTIELS',title:'Ton panier',close:'Fermer le panier',totals:['Sous-total','Livraison Suisse','Total','Économies'],details:'Voir le panier',payments:'Moyens de paiement',emptyTitle:'Ton panier est vide.',emptyCopy:'Découvre nos soins.',discover:'Découvrir le kit déodorant '},
    de:{eyebrow:'DEINE ESSENTIALS',title:'Dein Warenkorb',close:'Warenkorb schliessen',totals:['Zwischensumme','Versand Schweiz','Gesamt','Ersparnis'],details:'Warenkorb ansehen',payments:'Zahlungsmethoden',emptyTitle:'Dein Warenkorb ist leer.',emptyCopy:'Entdecke unsere Pflege.',discover:'Deodorant-Set entdecken '},
    en:{eyebrow:'YOUR ESSENTIALS',title:'Your cart',close:'Close cart',totals:['Subtotal','Swiss delivery','Total','Savings'],details:'View cart',payments:'Payment methods',emptyTitle:'Your cart is empty.',emptyCopy:'Discover our care products.',discover:'Discover the deodorant kit '}
  })[lang];
  const pricingRules = config.pricingRules || {};
  const products = new Map();
  const requests = new Map();
  const variants = new Map();
  const formStates = new WeakMap();
  let viewError = '';
  const forms = [...document.querySelectorAll('form.pdp-purchase')];
  const roseCampaignBlocked = form => form?.dataset.roseSalesEnabled === 'false' || (window.BasicCampaignRetirement?.isEnded() && (form?.id === 'rose-cart-form' || form?.querySelector('[value="58641264509192"]')));
  const roseCampaignMessage = {fr:'Cette recharge est actuellement indisponible.',de:'Diese Nachfüllung ist derzeit nicht verfügbar.',en:'This refill is currently unavailable.'}[lang] || 'Cette recharge est actuellement indisponible.';
  const idOf = value => String(value || '').split('/').pop();
  function indexProduct(product) {
    if (!product || !Array.isArray(product.variants)) return;
    if (product.handle) products.set(product.handle, product);
    for (const variant of product.variants) variants.set(idOf(variant.id), {variant, product});
  }
  indexProduct(config.currentProduct);
  Object.values(config.products || {}).forEach(indexProduct);
  function handleFor(id, form) {
    const found = variants.get(String(id));
    if (found?.product.handle) return found.product.handle;
    const mapped = config.variantProducts?.[id];
    if (mapped) return String(mapped).replace(/^\/products\//, '').replace(/\.js$/, '');
    const productRoute = config.productRoutes?.[config.localPage];
    if (productRoute && !form?.classList.contains('serum-quick-form')) return String(productRoute).split('/products/')[1]?.split(/[?#]/)[0];
    return null;
  }
  async function loadProduct(handle) {
    if (handle === 'le-rose-recharge-deodorant-ose-2026' && window.BasicCampaignRetirement?.isEnded()) throw new Error(strings.unavailable);
    if (!handle || !/^[a-z0-9-]+$/.test(handle)) throw new Error(strings.failed);
    if (!requests.has(handle)) {
      const request = fetch(cart.route(`products/${handle}.js`), {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}})
        .then(async response => {
          if (!response.ok) throw new Error(strings.unavailable);
          const product = await response.json();
          if (!Array.isArray(product.variants)) throw new Error(strings.failed);
          indexProduct(product); return product;
        });
      requests.set(handle, request);
    }
    return requests.get(handle);
  }
  async function ensureVariant(id, form) {
    const handle = handleFor(id, form);
    await loadProduct(handle);
    const found = variants.get(String(id));
    if (!found || found.product.handle !== handle) throw new Error(strings.unavailable);
    return found;
  }
  function plansFor(variant, product) {
    const plans = new Map((product.selling_plan_groups || []).flatMap(group => group.selling_plans || []).map(plan => [idOf(plan.id), plan]));
    return (variant.selling_plan_allocations || []).map(allocation => {
      const id = idOf(allocation.selling_plan_id || allocation.selling_plan?.id);
      const plan = plans.get(id) || allocation.selling_plan;
      return {id, name:plan?.name || '', frequency:(plan?.options || []).map(option => option.value).filter(Boolean).join(' · '), price:Number(allocation.price), allocation};
    }).filter(plan => /^\d+$/.test(plan.id) && plan.name && Number.isFinite(plan.price));
  }
  function allIds(form) {
    const ids = new Set();
    for (const element of form.querySelectorAll('[name="id"], [data-id], [data-variant], input[name$="[id]"]')) {
      if (element.closest('.klaviyo-star-rating-widget, #klaviyo-reviews-all')) continue;
      const id = element.dataset.variant || element.dataset.id || element.value;
      if (/^\d+$/.test(String(id || ''))) ids.add(String(id));
    }
    return [...ids];
  }
  function formNote(form, message, alert = false) {
    let note = form.querySelector('.shopify-commerce-note');
    if (!note) {note = document.createElement('p'); note.className = 'shopify-commerce-note'; form.append(note);}
    note.textContent = message; note.setAttribute('role', alert ? 'alert' : 'status');
    note.hidden = !message;
  }
  function formButtons(form) {
    return [...form.querySelectorAll('button[type="submit"]'), ...document.querySelectorAll(`button[form="${form.getAttribute('id')}"]`)];
  }
  function selectedLines(form) {
    try {return cart.parseForm(form);} catch {return [];}
  }
  function syncSubscription(form, entry) {
    if (form.classList.contains('serum-quick-form')) return;
    const state = formStates.get(form);
    const availablePlans = plansFor(entry.variant, entry.product);
    let widget = form.querySelector('.deo-subscription');
    let hidden = form.querySelector('input[name="selling_plan"]');
    if (!availablePlans.length) {
      if (widget) widget.hidden = true;
      if (hidden) {hidden.disabled = true; hidden.value = '';}
      for (const offer of form.querySelectorAll('input[name="classik-offer"], input[name="boise-offer"], input[name="catalog-offer"]')) {
        offer.disabled = false; offer.closest('label')?.classList.remove('deo-subscription-unavailable');
      }
      state.subscribed = false; return;
    }
    if (!widget) {
      widget = document.createElement('fieldset'); widget.className = 'deo-subscription';
      const legend = document.createElement('legend'); legend.textContent = strings.planLegend; widget.append(legend);
      for (const [value, label] of [['once',strings.once], ['subscribe',strings.subscribe]]) {
        const choice = document.createElement('label'); choice.className = 'deo-subscription-choice';
        const radio = document.createElement('input'); radio.type = 'radio'; radio.name = 'purchase-mode'; radio.value = value; radio.checked = value === 'once';
        const span = document.createElement('span'); span.textContent = label; choice.append(radio,span); widget.append(choice);
      }
      const frequency = document.createElement('fieldset'); frequency.className = 'deo-subscription-frequency';
      const frequencyLegend = document.createElement('legend'); frequencyLegend.textContent = strings.frequency;
      const choices = document.createElement('div'); choices.className = 'deo-subscription-plans';
      frequency.append(frequencyLegend,choices); widget.append(frequency);
      (form.querySelector('.catalog-offers, .catalog-quantity-line, .classik-purchase-summary') || form.firstChild)?.before(widget);
      if (!widget.parentNode) form.prepend(widget);
      hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = 'selling_plan'; hidden.disabled = true; form.append(hidden);
      widget.addEventListener('change', event => {
        state.subscribed = widget.querySelector('input[value="subscribe"]').checked;
        if (event.target.matches('input[data-deo-plan]')) state.planId = event.target.value;
        if (state.subscribed) {
          const single = form.querySelector('input[name="classik-offer"][value="1"], input[name="boise-offer"][value="1"], input[name="catalog-offer"][value="1"]');
          if (single && !single.checked) {single.checked = true; single.dispatchEvent(new Event('change', {bubbles:true}));}
        }
        synchronize(form);
      });
    }
    widget.hidden = false;
    if (!availablePlans.some(plan => plan.id === state.planId)) state.planId = availablePlans[0].id;
    const choices = widget.querySelector('.deo-subscription-plans');
    const planIds = availablePlans.map(plan => plan.id).join(',');
    if (choices.dataset.planIds !== planIds) {
      choices.replaceChildren(...availablePlans.map(plan => {
        const choice = document.createElement('label'); choice.className = 'deo-subscription-plan';
        const radio = document.createElement('input'); radio.type = 'radio'; radio.name = `${form.getAttribute('id')}-subscription-frequency`; radio.value = plan.id; radio.dataset.deoPlan = '';
        choice.append(radio,document.createElement('span'),document.createElement('small'),document.createElement('strong'));
        return choice;
      }));
      choices.dataset.planIds = planIds;
    }
    for (const choice of choices.children) {
      const radio = choice.querySelector('input');
      const plan = availablePlans.find(plan => plan.id === radio.value);
      radio.checked = plan.id === state.planId;
      choice.classList.toggle('is-selected', radio.checked);
      const frequency = (plan.frequency || plan.name).replace(/\s+/g, ' ').trim();
      const months = {'Livrez chaque mois':1, 'Livrez tous les 2 mois':2, 'Livrez tous les 3 mois':3}[frequency];
      const labels = ({fr:['Chaque mois','Tous les 2 mois','Tous les 3 mois'],de:['Jeden Monat','Alle 2 Monate','Alle 3 Monate'],en:['Every month','Every 2 months','Every 3 months']})[lang] || ['Chaque mois','Tous les 2 mois','Tous les 3 mois'];
      choice.querySelector('span').textContent = months ? labels[months - 1] : frequency;
      const comparison = Number(plan.allocation.compare_at_price || entry.variant.price);
      const discount = comparison > plan.price ? Math.round((comparison - plan.price) / comparison * 100) : 0;
      const saving = choice.querySelector('small'); saving.hidden = discount <= 0; saving.textContent = discount > 0 ? `−${discount} %` : '';
      choice.querySelector('strong').textContent = cart.money(plan.price / 100);
    }
    widget.querySelector('.deo-subscription-frequency').hidden = !state.subscribed;
    widget.querySelectorAll('.deo-subscription-choice').forEach(label => {
      const radio = label.querySelector('input'); radio.checked = (radio.value === 'subscribe') === state.subscribed; label.classList.toggle('is-selected', radio.checked);
    });
    hidden.disabled = !state.subscribed; hidden.value = state.subscribed ? state.planId : '';
    for (const offer of form.querySelectorAll('input[name="classik-offer"], input[name="boise-offer"], input[name="catalog-offer"]')) {
      if (offer.value !== '1') {offer.disabled = state.subscribed; offer.closest('label')?.classList.toggle('deo-subscription-unavailable', state.subscribed);}
    }
  }
  function setText(id, value) {const element = document.getElementById(id); if (element) element.textContent = value;}
  function syncSubscriptionButtonLabel(form, state) {
    const label = form.querySelector('.pdp-add-button > span');
    if (!label) return;
    const page = String(config.localPage || '');
    const protectedPage = page === 'le-rose' || page === 'le-rose.html' || page.includes('kit-');
    // The configurator has already switched a subscription to offer 1 here.
    // Preserve its current one-time wording, including its quantity wording.
    if (!protectedPage && label.textContent !== strings.subscribe) state.onceButtonLabel = label.textContent;
    if (state.subscribed) label.textContent = strings.subscribe;
    else if (!protectedPage && label.textContent === strings.subscribe && state.onceButtonLabel) label.textContent = state.onceButtonLabel;
  }
  function completeSelection(formId, lines) {
    if (formId === 'kit-cart-form') return lines.some(line => line.properties?._basic_item_role === 'refill' && line.quantity > 0);
    if (formId === 'lip-cart-form') return lines.length >= 2 && lines.slice(1).some(line => line.quantity > 0);
    return lines.length > 0;
  }
  function incompleteMessage(formId) {
    if (formId === 'lip-cart-form') return {fr:'Choisis au moins un lot de baumes.',de:'Wählen Sie mindestens ein Lippenbalsam-Set.',en:'Choose at least one lip balm refill pack.'}[lang] || 'Choisis au moins un lot de baumes.';
    return {fr:'Choisis au moins une recharge.',de:'Wählen Sie mindestens eine Nachfüllung.',en:'Choose at least one refill.'}[lang] || 'Choisis au moins une recharge.';
  }
  function previewPrice(lines, entries, formId, state) {
    let gross = 0;
    for (let index = 0; index < lines.length; index++) {
      const entry = entries[index];
      const plan = state.subscribed && lines.length === 1 ? plansFor(entry.variant, entry.product).find(plan => plan.id === state.planId) : null;
      gross += (plan ? plan.price : Number(entry.variant.price)) * lines[index].quantity;
    }
    let saving = 0, verified = false;
    if (!state.subscribed && pricingRules.verifiedAt && pricingRules.deodorantBundle === true && lines.length === 1 && (pricingRules.deodorantVariantIds || []).map(String).includes(lines[0].id)) {
      const count = lines[0].quantity;
      saving = count === 3 ? 300 : count === 6 ? Number(entries[0].variant.price) : 0;
      verified = [1,3,6].includes(count);
    }
    if (formId === 'kit-cart-form' && pricingRules.verifiedAt && pricingRules.deodorantKit === true) {
      const applicatorIndex = lines.findIndex(line => line.properties?._basic_item_role === 'applicator');
      const refillLines = lines.filter(line => line.properties?._basic_item_role === 'refill');
      const count = refillLines.reduce((sum,line) => sum + line.quantity, 0);
      if (applicatorIndex >= 0 && lines[applicatorIndex].quantity === 1 && count > 0 && refillLines.length === lines.length - 1) {
        saving = count >= 5 ? Number(entries[applicatorIndex].variant.price) : count >= 2 ? 400 : 0;
        verified = true;
      }
    }
    return {gross,total:Math.max(0,gross-saving),saving,verified};
  }
  function synchronize(form) {
    if (roseCampaignBlocked(form)) {
      form.dataset.shopifyBlocked = 'true';
      formButtons(form).forEach(button => {button.disabled = true;});
      return;
    }
    const state = formStates.get(form);
    if (!state || !state.loaded) return;
    const lines = selectedLines(form);
    const entries = lines.map(line => variants.get(line.id));
    const formId = form.getAttribute('id');
    if (!completeSelection(formId, lines)) {
      form.dataset.shopifyBlocked = 'true';
      for (const button of formButtons(form)) button.disabled = true;
      formNote(form, incompleteMessage(formId));
      // The original configurator owns its empty-state CTA and starting price
      // ("Dès CHF 24.–" / "Dès CHF 21.–"). Do not replace them by applicator-only prices.
      return;
    }
    if (lines.length === 1 && entries[0]) syncSubscription(form, entries[0]);
    const valid = lines.length > 0 && entries.every(entry => entry && entry.variant.available === true);
    form.dataset.shopifyBlocked = valid ? 'false' : 'true';
    for (const button of formButtons(form)) button.disabled = !valid || cart.pending;
    if (!valid) {formNote(form, strings.unavailable, true); return;}
    const estimate = previewPrice(lines, entries, formId, state);
    const formatted = cart.money(estimate.total / 100);
    const targets = {
      'catalog-cart-form':['catalog-total','catalog-sticky-price'],
      'classik-cart-form':['classik-total','classik-selection-price','classik-sticky-price'],
      'boise-cart-form':['boise-total','boise-selection-price','boise-sticky-price'],
      'serum-cart-form':['serum-total','serum-button-price','serum-sticky-price'],
      'kit-cart-form':['kit-add-price','kit-summary-price','kit-selection-price','kit-sticky-price'],
      'lip-cart-form':['lip-add-price','lip-summary-price','lip-selection-price','lip-sticky-price'],
      'rose-cart-form':['rose-total','rose-selection-price','rose-sticky-price']
    };
    (targets[formId] || []).forEach(id => setText(id, formatted));
    if (formId === 'serum-cart-form') setText('serum-shipping-detail', strings.paymentNote);
    if (lines.length === 1) {
      const unit = Number(entries[0].variant.price) / 100;
      form.dataset.productPrice = String(unit);
      for (const option of form.querySelectorAll('input[name="classik-format"]')) {
        const entry = variants.get(option.dataset.variant);
        if (entry) {option.dataset.price = String(Number(entry.variant.price) / 100); option.closest('label')?.querySelector('b')?.replaceChildren(cart.money(Number(entry.variant.price) / 100));}
      }
      for (const count of [1,3,6]) {
        const eligible = pricingRules.verifiedAt && pricingRules.deodorantBundle === true && (pricingRules.deodorantVariantIds || []).map(String).includes(lines[0].id);
        const savings = eligible ? count === 3 ? 3 : count === 6 ? unit : 0 : 0;
        const amount = cart.money(unit * count - savings);
        setText(`classik-offer-price-${count}`, amount);
        setText(`boise-offer-price-${count}`, amount);
        const label = form.querySelector(`[data-offer-price="${count}"]`); if (label) label.textContent = amount;
        const savingText = `${savingsLabel} ${cart.money(savings)}`;
        setText(`classik-offer-savings-${count}`, savingText);
        setText(`boise-offer-savings-${count}`, savingText);
        const savingLabel = form.querySelector(`[data-offer-saving="${count}"]`); if (savingLabel) savingLabel.textContent = savingText;
      }
    }
    const bundleEligible = pricingRules.verifiedAt && pricingRules.deodorantBundle === true && lines.length === 1 && (pricingRules.deodorantVariantIds || []).map(String).includes(lines[0].id) && !state.subscribed;
    for (const element of form.querySelectorAll('[id*="-savings"], [id$="-saving"], [id*="-compare"], [data-offer-saving], [data-offer-compare], .classik-compare-note')) {
      const isOfferLabel = /(?:offer-(?:savings|compare)|offer-(?:saving|compare))/.test(element.id) || element.hasAttribute('data-offer-saving') || element.hasAttribute('data-offer-compare');
      element.hidden = isOfferLabel ? !bundleEligible : estimate.saving <= 0;
    }
    for (const id of ['kit-savings','lip-savings','classik-selection-saving','boise-selection-saving']) {
      const element = form.querySelector(`#${id}`);
      if (element) {element.hidden = estimate.saving <= 0; element.textContent = `${cart.money(estimate.saving / 100)} ${savedWord}`;}
    }
    for (const id of ['kit-summary-compare','lip-summary-compare']) {
      const element = form.querySelector(`#${id}`);
      if (element) {element.hidden = estimate.saving <= 0; element.textContent = cart.money(estimate.gross / 100);}
    }
    for (const option of form.querySelectorAll('[data-id]')) {
      if (variants.get(String(option.dataset.id))?.variant.available !== true) option.querySelectorAll('.kit-step-plus').forEach(button => {button.disabled = true;});
    }
    formNote(form, '');
    syncSubscriptionButtonLabel(form, state);
  }
  function schedule(form) {
    const state = formStates.get(form); if (!state || state.frame) return;
    state.frame = requestAnimationFrame(() => {state.frame = 0; synchronize(form);});
  }
  async function prepareForm(form) {
    const state = {loaded:false, subscribed:false, planId:'', frame:0}; formStates.set(form,state);
    form.dataset.shopifyBlocked = 'true'; formButtons(form).forEach(button => {button.disabled = true;});
    if (roseCampaignBlocked(form)) {formNote(form, roseCampaignMessage); return;}
    formNote(form, strings.checking);
    form.action = cart.route('cart/add'); form.method = 'post';
    try {
      const ids = allIds(form);
      if (!ids.length) throw new Error(strings.unavailable);
      if (form.hasAttribute('data-catalog-refill-builder')) {
        const primaryHandles = [...new Set([...form.querySelectorAll('input[name="id"]')].map(input => handleFor(input.value, form)))];
        await Promise.all(primaryHandles.map(loadProduct));
        const optionalHandles = [...new Set([...form.querySelectorAll('[data-catalog-refill]')].map(input => handleFor(input.dataset.id, form)))];
        await Promise.allSettled(optionalHandles.map(loadProduct));
      } else {
        await Promise.all([...new Set(ids.map(id => handleFor(id, form)))].map(loadProduct));
      }
      for (const option of form.querySelectorAll('[data-variant], [data-id], input[name="id"][type="radio"]')) {
        const id = option.dataset.variant || option.dataset.id || option.value;
        const entry = variants.get(String(id));
        const available = entry?.variant.available === true;
        if (option.matches('input')) option.disabled = !available;
        if (!available) {
          option.closest('label')?.classList.add('is-unavailable');
          option.querySelectorAll?.('.kit-step-plus').forEach(button => {button.disabled = true;});
        }
        if (entry && option.dataset.price !== undefined) option.dataset.price = String(Number(entry.variant.price) / 100);
        if (option.hasAttribute('data-catalog-refill')) {
          if (!available) option.checked = false;
          const label = option.closest('.catalog-refill-card')?.querySelector('[data-refill-price]');
          if (label && entry) label.textContent = cart.money(Number(entry.variant.price) / 100);
        }
      }
      if (form.hasAttribute('data-catalog-refill-builder')) form.dispatchEvent(new CustomEvent('basic-catalog-sync'));
      state.loaded = true; synchronize(form);
    } catch (error) {formNote(form, error.message || strings.failed, true);}
    for (const event of ['change','input','click']) form.addEventListener(event, () => schedule(form));
  }
  async function validate(lines, form) {
    if (roseCampaignBlocked(form)) throw new Error(roseCampaignMessage);
    await ready;
    if (!formStates.get(form)?.loaded) throw new Error(strings.failed);
    if (!completeSelection(form.getAttribute('id'), lines)) throw new Error(incompleteMessage(form.getAttribute('id')));
    for (const line of lines) {
      const {variant,product} = await ensureVariant(line.id, form);
      if (variant.available !== true) throw new Error(strings.unavailable);
      if (line.selling_plan && !plansFor(variant,product).some(plan => plan.id === String(line.selling_plan))) throw new Error(strings.planUnavailable);
      if (product.requires_selling_plan && !line.selling_plan) throw new Error(strings.planUnavailable);
    }
  }
  function metadata(form) {
    const productHandle = config.productHandles?.[config.localPage];
    let selectionImage = form.dataset.productImage || config.productPackshots?.[productHandle];
    if (form.id === 'kit-cart-form') selectionImage = form.querySelector('input[name="kit-color-choice"]:checked')?.dataset.galleryHero || selectionImage;
    if (form.id === 'lip-cart-form') selectionImage = form.querySelector('input[name="lip-color-choice"]:checked')?.dataset.image || selectionImage;
    const multi = selectedLines(form).length > 1;
    if (multi && form.hasAttribute('data-catalog-refill-builder')) {
      const selectionTitle = {fr:'Applicateur lèvres + recharges',de:'Lippenbalsam-Applikator + Nachfüllungen',en:'Lip balm applicator + refills'}[lang] || 'Applicateur lèvres + recharges';
      const color = form.querySelector('input[name="id"]:checked')?.dataset.title;
      const applicatorCount = Number(form.querySelector('#catalog-quantity')?.value || 1);
      const applicatorDetail = applicatorCount > 1 ? `${applicatorCount} × ${color}` : color;
      const refills = [...form.querySelectorAll('[data-catalog-refill]:checked')].filter(input => !input.disabled).map(input => {
        const count = input.closest('.catalog-refill-card')?.querySelector('[data-refill-quantity]')?.value || '1';
        return `${count} × ${input.dataset.title}`;
      });
      return {page:config.localPage, source:form.getAttribute('id'), title:selectionTitle, detail:[applicatorDetail,...refills].filter(Boolean).join(' · '), image:selectionImage};
    }
    const labels = {
      'kit-cart-form':{fr:'Le kit déodorant rechargeable',de:'Das nachfüllbare Deo-Set',en:'The refillable deodorant kit'}[lang] || 'Le kit déodorant rechargeable',
      'lip-cart-form':{fr:'Le kit baume à lèvres',de:'Das Lippenbalsam-Set',en:'The lip balm kit'}[lang] || 'Le kit baume à lèvres',
      'rose-cart-form':'Le Rose · OSE Thérapies'
    };
    const detailIds = {'kit-cart-form':['kit-selected-color','kit-summary-contents'], 'lip-cart-form':['lip-selected-color','lip-summary-contents'], 'rose-cart-form':['rose-selection-summary']};
    const detail = (detailIds[form.getAttribute('id')] || []).map(id => document.getElementById(id)?.textContent.trim()).filter(Boolean).join(' · ');
    return {page:config.localPage, source:form.getAttribute('id'), image:selectionImage, ...(multi ? {title:labels[form.getAttribute('id')] || form.dataset.productTitle || document.querySelector('h1')?.textContent.trim(), detail} : {})};
  }
  async function restoreRestockedForm() {
    const block = document.querySelector('.catalog-unavailable');
    const productRoute = config.productRoutes?.[config.localPage];
    if (!block || !productRoute) return null;
    const handle = String(productRoute).split('/products/')[1]?.split(/[?#]/)[0];
    try {
      const product = await loadProduct(handle);
      const available = product.variants.filter(variant => variant.available === true);
      if (!available.length) return null;
      const form = document.createElement('form'); form.id = 'catalog-cart-form'; form.className = 'pdp-purchase catalog-purchase';
      form.dataset.catalogProduct = 'true'; form.dataset.productTitle = product.title || '';
      form.dataset.productPrice = String(Number(available[0].price) / 100);
      form.dataset.productImage = config.productPackshots?.[handle] || (typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.src || '');
      const select = document.createElement('select'); select.name = 'id'; select.setAttribute('aria-label', strings.once);
      for (const variant of product.variants) {
        const option = document.createElement('option'); option.value = idOf(variant.id);
        option.textContent = variant.title === 'Default Title' ? product.title : variant.title;
        option.disabled = variant.available !== true; option.selected = idOf(variant.id) === idOf(available[0].id); select.append(option);
      }
      if (product.variants.length === 1) select.hidden = true;
      const quantityLine = document.createElement('div'); quantityLine.className = 'catalog-quantity-line';
      const quantity = document.createElement('input'); quantity.name = 'quantity'; quantity.type = 'number'; quantity.min = '1'; quantity.max = '20'; quantity.value = '1';
      quantity.setAttribute('aria-label', {fr:'Quantité',de:'Menge',en:'Quantity'}[lang] || 'Quantité'); quantityLine.append(quantity);
      const button = document.createElement('button'); button.type = 'submit'; button.className = 'pdp-add-button';
      const label = document.createElement('span'); label.textContent = {fr:'Ajouter au panier',de:'In den Warenkorb',en:'Add to cart'}[lang] || 'Ajouter au panier';
      const price = document.createElement('strong'); price.id = 'catalog-total'; price.textContent = cart.money(Number(available[0].price) / 100);
      button.append(label,price); form.append(select,quantityLine,button); block.replaceWith(form); return form;
    } catch {return null;} // Preserve the sold-out block if availability cannot be confirmed.
  }
  const ready = (async () => {
    const preparing = forms.map(prepareForm);
    const restored = await restoreRestockedForm();
    if (restored) {forms.push(restored); preparing.push(prepareForm(restored));}
    await Promise.all(preparing);
  })();
  function rewardMessage(summary) {
    if (!summary.loaded) return strings.busy;
    if (summary.giftUnlocked) return strings.giftAdded;
    if (summary.giftUnavailable) return strings.giftUnavailable;
    if (config.cartRules?.isB2B || summary.currency !== 'CHF') return '';
    if (summary.shippingRemaining > 0) {
      const amount = cart.money(summary.shippingRemaining);
      return {fr:`Encore ${amount} pour la livraison offerte.`,de:`Noch ${amount} bis zum Gratisversand.`,en:`${amount} to free shipping.`}[lang] || `Encore ${amount} pour la livraison offerte.`;
    }
    if (summary.giftRemaining > 0) {
      const amount = cart.money(summary.giftRemaining);
      return {fr:`Encore ${amount} pour ton cadeau.`,de:`Noch ${amount} bis zum Geschenk.`,en:`${amount} to your free gift.`}[lang] || `Encore ${amount} pour ton cadeau.`;
    }
    return {fr:'Cadeau en préparation.',de:'Geschenk wird vorbereitet.',en:'Preparing your gift.'}[lang] || 'Cadeau en préparation.';
  }
  window.BasicShopifyCommerce = {ready, validate, metadata, plansFor, previewPrice, rewardMessage, prepareSubmission:synchronize};

  function status(message, alert = false) {
    let element = document.getElementById('basic-shopify-status');
    if (!element) {element = document.createElement('p'); element.id = 'basic-shopify-status'; element.className = 'cart-help'; document.querySelector('#cart-content, #order-content, .cart-drawer-body, main')?.append(element);}
    if (!element) return;
    element.textContent = message; element.setAttribute('role', alert ? 'alert' : 'status'); element.hidden = !message;
  }
  function syncDrawerLabels() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer || !drawerLabels) return;
    const plain = (selector,value) => {const element = drawer.querySelector(selector); if (element) element.textContent = value;};
    const leading = (selector,value) => {
      const element = drawer.querySelector(selector);
      if (element?.firstChild?.nodeType === 3) element.firstChild.textContent = value;
      else if (element) element.textContent = value;
    };
    plain('.cart-drawer-eyebrow',drawerLabels.eyebrow);
    leading('.cart-drawer-title',drawerLabels.title);
    drawer.querySelector('.cart-drawer-close')?.setAttribute('aria-label',drawerLabels.close);
    drawer.querySelectorAll('.cart-drawer-totals > div:not([data-basic-cart-discount-row]) > span').forEach((element,index) => {if (drawerLabels.totals[index]) element.textContent = drawerLabels.totals[index];});
    plain('.cart-drawer-secondary',drawerLabels.details);
    drawer.querySelector('.cart-drawer-payments')?.setAttribute('aria-label',drawerLabels.payments);
    plain('.cart-drawer-empty h3',drawerLabels.emptyTitle);
    plain('.cart-drawer-empty p',drawerLabels.emptyCopy);
    leading('.cart-drawer-empty a',drawerLabels.discover);
  }
  function protectedCartDiscountView(raw) {
    const protectedPage = page => page === 'le-rose' || page === 'le-rose.html' || page.includes('kit-');
    if (protectedPage(String(config.localPage || ''))) return true;
    return (raw?.items || []).some(line => {
      const handle = String(line.handle || '');
      const properties = line.properties || {};
      return handle.startsWith('le-rose-') || handle.includes('kit-') ||
        protectedPage(String(properties._basic_local_page || '')) ||
        /^kit\b/i.test(String(properties._basic_selection_title || ''));
    });
  }
  function cartDiscountBreakdown(raw) {
    if (!raw || protectedCartDiscountView(raw)) return null;
    const before = Number(raw.items_subtotal_price);
    const after = Number(raw.total_price);
    if (!Number.isSafeInteger(before) || !Number.isSafeInteger(after) || after < 0 || before <= after) return null;
    const amount = before - after;
    const applications = (raw.cart_level_discount_applications || []).map(discount => ({
      title:String(discount.title || '').trim(),
      amount:Number(discount.total_allocated_amount)
    })).filter(discount => Number.isSafeInteger(discount.amount) && discount.amount > 0);
    const allocated = applications.reduce((sum, discount) => sum + discount.amount, 0);
    return {before, discounts:allocated === amount ? applications : [{title:'',amount}]};
  }
  function syncCartDiscountBreakdown(summary) {
    document.querySelectorAll('[data-basic-cart-discount-row]').forEach(row => row.remove());
    document.querySelectorAll('[data-basic-cart-discount-savings-hidden]').forEach(row => {
      row.hidden = summary.savings <= 0;
      delete row.dataset.basicCartDiscountSavingsHidden;
    });
    for (const id of ['cart-subtotal','cart-drawer-subtotal','order-subtotal']) {
      const label = document.getElementById(id)?.parentElement?.querySelector('span');
      if (label?.dataset.basicCartSubtotalLabel) {
        label.textContent = label.dataset.basicCartSubtotalLabel;
        delete label.dataset.basicCartSubtotalLabel;
      }
    }
    const breakdown = cartDiscountBreakdown(cart.snapshot);
    if (!breakdown) return;
    for (const id of ['cart-savings-row','cart-drawer-savings-row']) {
      const row = document.getElementById(id);
      if (!row) continue;
      row.dataset.basicCartDiscountSavingsHidden = 'true';
      row.hidden = true;
    }
    for (const id of ['cart-subtotal','cart-drawer-subtotal','order-subtotal']) {
      const subtotal = document.getElementById(id);
      const row = subtotal?.parentElement;
      const label = row?.querySelector('span');
      if (!row || !label) continue;
      label.dataset.basicCartSubtotalLabel = label.textContent;
      label.textContent = cartDiscountLabels.after;
      const fragment = document.createDocumentFragment();
      const addRow = (title, value, discount = false) => {
        const detail = document.createElement('div');
        detail.dataset.basicCartDiscountRow = 'true';
        if (discount) detail.className = id === 'cart-drawer-subtotal' ? 'cart-drawer-savings' : 'cart-savings-row';
        const name = document.createElement('span');
        name.textContent = title;
        const price = document.createElement('strong');
        price.textContent = `${discount ? '−' : ''}${cart.money(value / 100)}`;
        detail.append(name, price);
        fragment.append(detail);
      };
      addRow(cartDiscountLabels.before, breakdown.before);
      for (const discount of breakdown.discounts) {
        addRow(discount.title ? `${cartDiscountLabels.discount} · ${discount.title}` : cartDiscountLabels.discount, discount.amount, true);
      }
      row.before(fragment);
    }
  }
  function syncCartViews() {
    const summary = cart.totals();
    syncDrawerLabels();
    syncCartDiscountBreakdown(summary);
    for (const id of ['cart-item-count','cart-drawer-count']) setText(id, summary.selectionCount ? `${summary.selectionCount} ${summary.selectionCount === 1 ? cartLabels.selection : cartLabels.selections}` : cartLabels.empty);
    for (const row of document.querySelectorAll('.cart-line, .cart-drawer-line')) {
      const title = row.querySelector('.cart-line-title, .cart-drawer-line-title')?.textContent || '';
      const remove = row.querySelector('.cart-remove, .cart-drawer-remove');
      if (remove) {remove.textContent = cartLabels.remove; remove.setAttribute('aria-label', cartLabels.removeAria(title));}
      const quantity = row.querySelector('.cart-quantity, .cart-drawer-quantity');
      if (quantity) {
        quantity.setAttribute('aria-label', cartLabels.quantityAria(title));
        const buttons = quantity.querySelectorAll('button');
        buttons[0]?.setAttribute('aria-label', cartLabels.minusAria(title));
        buttons[1]?.setAttribute('aria-label', cartLabels.plusAria(title));
      }
    }
    document.querySelectorAll('.cart-line-savings, .cart-drawer-line-savings, .order-item-price em').forEach(element => {element.textContent = element.textContent.replace(/ (?:économisés|gespart|saved)$/, ` ${savedWord}`);});
    const shipping = summary.uncertain ? strings.shipping : summary.delivery === 0 ? strings.freeShipping : cart.money(summary.delivery);
    const total = summary.uncertain ? `${cart.money(summary.known)}${strings.totalSuffix}` : cart.money(summary.known + summary.delivery);
    for (const id of ['cart-shipping','order-shipping','cart-drawer-shipping']) setText(id, shipping);
    for (const id of ['cart-total','order-total','cart-drawer-total']) setText(id, total);
    for (const id of ['cart-unknown-note','order-uncertain','cart-drawer-uncertain']) {const element = document.getElementById(id); if (element) {element.textContent = summary.uncertain ? strings.paymentNote : ''; element.hidden = !summary.uncertain;}}
    document.querySelectorAll('.cart-quantity button, .cart-remove, .cart-drawer-controls button').forEach(button => {
      if (cart.pending) button.disabled = true;
    });
    const checkout = document.getElementById('cart-checkout-button'); if (checkout) {checkout.disabled = cart.pending || !cart.loaded || !cart.read().length; checkout.firstChild.textContent = `${strings.checkout} `;}
    const drawerCheckout = document.getElementById('cart-drawer-checkout'); if (drawerCheckout) {drawerCheckout.disabled = cart.pending || !cart.loaded || !cart.read().length; drawerCheckout.querySelector('span').textContent = strings.checkout; drawerCheckout.setAttribute('aria-disabled', String(drawerCheckout.disabled));}
    const orderCheckout = document.getElementById('order-shopify-checkout'); if (orderCheckout) orderCheckout.disabled = cart.pending || !cart.loaded || !cart.read().length;
    for (const form of forms) if (formStates.get(form)?.loaded) synchronize(form);
  }
  const originalRewardsRender = window.BasicCartRewards?.render;
  if (originalRewardsRender) window.BasicCartRewards.render = (panel, summary) => {
    originalRewardsRender(panel, summary);
    panel.hidden = summary.currency !== 'CHF' || config.cartRules?.isB2B === true;
    const message = panel.querySelector('.cart-rewards-message');
    const value = rewardMessage(summary);
    if (message) message.textContent = value;
    panel.querySelector('[data-reward="shipping"]')?.classList.toggle('is-reached', summary.loaded && summary.shippingRemaining === 0);
    panel.querySelector('[role="progressbar"]')?.setAttribute('aria-valuetext', value);
    // Every populated legacy view calls rewards after rebuilding its rows and
    // totals, including drawer opens and synchronous post-click renders.
    syncCartViews();
  };
  const orderSummary = document.querySelector('.order-summary');
  if (orderSummary && !document.getElementById('order-shopify-checkout')) {
    const button = document.createElement('button'); button.type = 'button'; button.id = 'order-shopify-checkout'; button.className = 'cart-button cart-checkout-button'; button.textContent = strings.checkout; orderSummary.append(button);
    const note = orderSummary.querySelector('.order-next'); if (note) note.textContent = strings.paymentNote;
    const preview = document.querySelector('.order-preview-note'); if (preview) preview.hidden = true;
  }
  document.addEventListener('click', event => {
    // Legacy views recreate their quantity buttons immediately after write().
    // Guard the new buttons too while the authoritative mutation is pending.
    if (cart.pending && event.target.closest?.('.cart-quantity button, .cart-remove, .cart-drawer-controls button')) {
      event.preventDefault(); event.stopPropagation(); return;
    }
    const button = event.target.closest?.('#cart-drawer-checkout, #order-shopify-checkout');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    if (!cart.pending) cart.checkout();
  }, true);
  document.addEventListener('submit', event => {
    if (!event.target.matches?.('#cart-checkout-form')) return;
    event.preventDefault(); event.stopPropagation();
    if (!cart.pending) cart.checkout();
  }, true);
  window.addEventListener('basic-cart-change', syncCartViews);
  window.addEventListener('basic-cart-pending', event => {
    if (event.detail.pending) viewError = '';
    syncCartViews(); status(event.detail.pending ? strings.busy : viewError, Boolean(viewError));
  });
  window.addEventListener('basic-cart-error', event => {viewError = event.detail.message; status(viewError, true);});
  window.addEventListener('basic-cart-notice', event => {viewError = event.detail.message; status(viewError, true);});
  syncCartViews();
})();
